// Copyright 2016 Sorama B.V.

import { Color } from "services/Color/Color";

export abstract class IColorMap {
    name: string;

    abstract toColorRange(count: number): Color[];

    abstract toColor(value: number): Color;
}
